module.exports = __webpack_public_path__ + "23_pvisn.jpg?7da56ae54508e88609ba72c9ef9c9169";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_pvisn.jpg
// module id = 203
// module chunks = 0